import React  from 'react';

const overlay = (props) => {
  return <div id="overlay" className={`overlay ${props.isShown ? '' : 'overlay--hidden'}`}></div>
};

export default overlay;



// WEBPACK FOOTER //
// ./src/components/Overlay/Overlay.js